import { FirearmStorageLocationPLIEditorComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-pli-editor.component';
import { FirearmStorageLocationPLIItemComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-pli-item.component';
import { FirearmStorageLocationPLISearchComponent } from './domain/firearm_storage_location/search/firearm-storage-location-pli-search.component';
import { FirearmStorageLocationPLIDocumentComponent } from './domain/firearm_storage_location/editor/firearm-storage-location-pli-document.component';
import { MatPasswordStrengthModule } from "@angular-material-extensions/password-strength";
import { CDK_DRAG_CONFIG, DragDropConfig } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkColumnDef } from '@angular/cdk/table';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEn from '@angular/common/locales/en-GB';
import localeEnExtra from '@angular/common/locales/extra/en-GB';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MatMomentDateModule, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { DatetimeAdapter, MAT_DATETIME_FORMATS } from '@mat-datetimepicker/core';
import { MAT_MOMENT_DATETIME_FORMATS, MatMomentDatetimeModule, MomentDatetimeAdapter } from '@mat-datetimepicker/moment';
import { AUTHENTICATION_REQUIRED_DECIDER, AppErrorHandler, AuthTokenCookiePreAuthService, AuthTokenLinkTokenReplacer, AuthTokenPreAuthService, BooleanFormatPipe, BusyHttpInterceptor, CODE_LOOKUP_PIPE, CrudCanDeactivate, CurrentUserLoginInterceptor, DEBUG_SERVICE, DebugServiceImpl, DialogErrorInfoHandler, ENVIRONMENT, ERROR_INFO_HANDLERS, EnvironmentLinkTokenReplacer, ErrorDialogComponent, FormStorageLoginInterceptor, HateoasResponseInterceptor, LINK_TOKEN_REPLACER, LOGIN_SUCCESS_INTERCEPTORS, LocalStorageLinkTokenReplacer, NavigationLoginInterceptor, OAuthPreAuthService, PRE_AUTH_SERVICE, PropegateTokenInterceptor, SessionStorageLinkTokenReplacer, USER_NOTIFICATION_UTIL_SERVICE_PROVIDER, UimCommonModule, UnauthorizedAuthenticationRequiredDecider, WithCredentialsInterceptor, dragConstrainPositionToWindowWithMargin } from '@scisys-uim/uim-common';
import { AssetsModelModule, registerAssetModelCrudEntityConstructors } from 'assets-model';
import { AmmunitionStockNotificationService, AssetsServiceModule, FirearmAssignmentNotificationService, RangerNotifcationUtilService, SystemMessageNotificationUtilService, ToDoListNotificationUtilService, TransferAssetNotificationUtilService } from 'assets-service';
import { AutosizeModule } from "ngx-autosize";
import { QuillModule } from 'ngx-quill';
import { AssetMaintenanceNotificationUtilService } from "projects/assets-service/src/public-api";
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AmmunitionStockEditorComponent } from './domain/ammunition_stock/editor/ammunition-stock-editor.component';
import { AmmunitionStockEventRowsEditorComponent } from "./domain/ammunition_stock/editor/ammunition-stock-event-rows-editor.component";
import { AmmunitionStockEventRowsComponent } from "./domain/ammunition_stock/editor/ammunition-stock-event-rows.component";
import { AmmunitionStockItemComponent } from './domain/ammunition_stock/editor/ammunition-stock-item.component';
import { AmmunitionStockEventHistoryComponent, AmmunitionStockEventListComponent, AmmunitionStockEventSearchComponent } from "./domain/ammunition_stock/search/ammunition-stock-event-search.component";
import { AmmunitionStockSearchComponent } from './domain/ammunition_stock/search/ammunition-stock-search.component';
import { ElectricalAspectItemComponent } from "./domain/aspects/editor/electrical-aspect-item.component";
import { MaintenanceAspectItemComponent } from "./domain/aspects/editor/maintenance-aspect-item.component";
import { MechanicalAspectItemComponent } from "./domain/aspects/editor/mechanical-aspect-item.component";
import { ElectricalAspectSearchResultColumnsComponent } from "./domain/aspects/search/electrical-aspect-search.component";
import { MaintenanceAspectSearchResultColumnsComponent } from "./domain/aspects/search/maintenance-aspect-search.component";
import { MechanicalAspectSearchResultColumnsComponent } from "./domain/aspects/search/mechanical-aspect-search.component";
import { AssetAuditListComponent } from "./domain/asset/audit/asset-audit-list.component";
import { AssetEditorComponent } from "./domain/asset/editor/asset-editor.component";
import { AssetAdditionalInfoControlComponent, AssetAspectsControlComponent, AssetItemComponent, AssetTagsControlComponent } from "./domain/asset/editor/asset-item.component";
import { AssetSearchComponent, AssetSearchFiltersComponent, AssetSearchResultColumnsComponent } from "./domain/asset/search/asset-search.component";
import { AssetDataUploadComponent } from "./domain/asset/upload/asset-data-upload.component";
import { AssetMaintenanceDocumentEditDialogComponent, AssetMaintenanceDocumentRowsComponent } from "./domain/assetmaintenance/editor/asset-maintenance-document-rows.component";
import { AssetMaintenanceEditorComponent } from "./domain/assetmaintenance/editor/asset-maintenance-editor.component";
import { AssetMaintenanceItemComponent } from "./domain/assetmaintenance/editor/asset-maintenance-item.component";
import { AssetMaintenanceRowsComponent } from "./domain/assetmaintenance/editor/asset-maintenance-rows.component";
import { AssetMaintenanceSearchComponent } from "./domain/assetmaintenance/search/asset-maintenance-search.component";
import { AssetTypeEditorComponent } from "./domain/assettype/editor/asset-type-editor.component";
import { AssetTypeItemComponent } from "./domain/assettype/editor/asset-type-item.component";
import { AssetTypeSearchComponent } from "./domain/assettype/search/asset-type-search.component";
import { BusinessUnitAddressEditorComponent } from "./domain/businessunit/editor/business-unit-address-editor.component";
import { BusinessUnitAddressItemComponent } from "./domain/businessunit/editor/business-unit-address-item.component";
import { BusinessUnitEditorComponent } from "./domain/businessunit/editor/business-unit-editor.component";
import { BusinessUnitEmailContactEditorComponent } from "./domain/businessunit/editor/business-unit-email-contact-editor.component";
import { BusinessUnitEmailContactItemComponent } from "./domain/businessunit/editor/business-unit-email-contact-item.component";
import { BusinessUnitItemComponent } from "./domain/businessunit/editor/business-unit-item.component";
import { BusinessUnitAddressSearchComponent } from "./domain/businessunit/search/business-unit-address-search.component";
import { BusinessUnitEmailContactSearchComponent } from "./domain/businessunit/search/business-unit-email-contact-search.component";
import { BusinessUnitSearchComponent } from "./domain/businessunit/search/business-unit-search.component";
import { CostCentreEditorComponent } from "./domain/costcentre/editor/cost-centre-editor.component";
import { CostCentreItemComponent } from "./domain/costcentre/editor/cost-centre-item.component";
import { CostCentreSearchComponent } from "./domain/costcentre/search/cost-centre-search.component";
import { TransferReminderEmailTemplatesComponent } from "./domain/email-templates/assets/transfer-reminder/transfer-reminder-email-templates.component";
import { FirearmAssignmentIssuePoliceNotifyEmailTemplatesComponent } from "./domain/email-templates/firearms/notify-police-issue/firearm-assignment-issue-police-notify-email-template.component";
import { FirearmAssignmentStorageAcquirePoliceNotifyEmailTemplatesComponent } from "./domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-acquire-police-notify-email-template.component";
import { FirearmAssignmentStorageDisposePoliceNotifyEmailTemplatesComponent } from "./domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-dispose-police-notify-email-template.component";
import { FirearmAssignmentStorageReturnPoliceNotifyEmailTemplatesComponent } from "./domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-return-police-notify-email-template.component";
import { FirearmAssignmentStorageTransferPoliceNotifyEmailTemplatesComponent } from "./domain/email-templates/firearms/notify-police-storage/firearm-assignment-storage-transfer-police-notify-email-template.component";
import { EmailTemplateParametersComponent } from "./domain/email-templates/template-parameters.component";
import { FirearmAuditListComponent } from "./domain/firearm/audit/firearm-audit-list.component";
import { FirearmAcquireDialogComponent } from "./domain/firearm/dialog/firearm-acquire-dialog.component";
import { FirearmDisposeDialogComponent } from "./domain/firearm/dialog/firearm-dispose-dialog.component";
import { FirearmSuspendDialogComponent } from "./domain/firearm/dialog/firearm-suspend-dialog.component";
import { FirearmTransferDialogComponent } from "./domain/firearm/dialog/firearm-transfer-dialog.component";
import { FirearmDocumentEditDialogComponent, FirearmDocumentRowsComponent } from "./domain/firearm/editor/firearm-document-rows.component";
import { FirearmEditorComponent } from "./domain/firearm/editor/firearm-editor.component";
import { FirearmItemComponent } from "./domain/firearm/editor/firearm-item.component";
import { FirearmSearchComponent, FirearmSearchResultColumnsComponent } from "./domain/firearm/search/firearm-search.component";
import { FirearmAssignmentActivationDialogComponent } from "./domain/firearm_assignment/dialog/firearm-assignment-activation-dialog.component";
import { FirearmAssignmentApprovalDialogComponent } from "./domain/firearm_assignment/dialog/firearm-assignment-approval-dialog.component";
import { FirearmAssignmentCancellationDialogComponent } from "./domain/firearm_assignment/dialog/firearm-assignment-cancellation-dialog.component";
import { FirearmAssignmentCreationDialogComponent } from "./domain/firearm_assignment/dialog/firearm-assignment-creation-dialog.component";
import { FirearmAssignmentEditorComponent } from "./domain/firearm_assignment/editor/firearm-assignment-editor.component";
import { FirearmAssignmentItemComponent } from "./domain/firearm_assignment/editor/firearm-assignment-item.component";
import { FirearmAssignmentLogEditorComponent } from "./domain/firearm_assignment/editor/firearm-assignment-log-editor.component";
import { FirearmAssignmentLogItemComponent } from "./domain/firearm_assignment/editor/firearm-assignment-log-item.component";
import { FirearmAssignmentPendingActionListComponent } from "./domain/firearm_assignment/list-pending/firearm-assignment-pending-action-list.component";
import { FirearmAssignmentListComponent, FirearmAssignmentSearchComponent } from "./domain/firearm_assignment/search/firearm-assignment-search.component";
import { FirearmPoolEditorComponent } from "./domain/firearm_pool/editor/firearm-pool-editor.component";
import { FirearmPoolItemComponent } from "./domain/firearm_pool/editor/firearm-pool-item.component";
import { FirearmPoolSearchComponent } from "./domain/firearm_pool/search/firearm-pool-search.component";
import { FirearmStorageLocationEditorComponent } from "./domain/firearm_storage_location/editor/firearm-storage-location-editor.component";
import { FirearmStorageLocationItemComponent } from "./domain/firearm_storage_location/editor/firearm-storage-location-item.component";
import { FirearmStorageLocationSearchComponent } from "./domain/firearm_storage_location/search/firearm-storage-location-search.component";
import { RangerAcknowledgeAssignmentComponent } from "./domain/ranger/acknowledge-assignment/acknowledge-assignment.component";
import { RangerLeavingDialogComponent } from "./domain/ranger/dialog/ranger-leaving-dialog.component";
import { RangerSetToPendingDialogComponent } from "./domain/ranger/dialog/ranger-set-to-pending-dialog.component";
import { RangerEditorComponent } from "./domain/ranger/editor/ranger-editor.component";
import { RangerItemComponent } from "./domain/ranger/editor/ranger-item.component";
import { RangerListComponent, RangerSearchComponent } from "./domain/ranger/search/ranger-search.component";
import { RangerFirearmAssignmentLogEditorComponent } from "./domain/ranger_firearm_assignment/editor/ranger-firearm-assignment-log-editor.component";
import { RangerFirearmAssignmentLogItemComponent } from "./domain/ranger_firearm_assignment/editor/ranger-firearm-assignment-log-item.component";
import { RefCodeEditorComponent } from "./domain/refcode/editor/ref-code-editor.component";
import { RefCodeItemComponent } from "./domain/refcode/editor/ref-code-item.component";
import { RefCodeSearchComponent } from "./domain/refcode/search/ref-code-search.component";
import { RoleEditorComponent } from "./domain/role/editor/role-editor.component";
import { RoleItemComponent } from "./domain/role/editor/role-item.component";
import { RoleSearchComponent } from "./domain/role/search/role-search.component";
import { SystemMessageDialogComponent } from "./domain/systemmessage/dialog/system-message-dialog.component";
import { SystemMessageSearchComponent } from "./domain/systemmessage/search/system-message-search.component";
import { RichTextSectionComponent } from "./domain/textsection/rich-text-sections/rich-text-section.component";
import { SimpleTextSectionComponent } from "./domain/textsection/rich-text-sections/simple-text-section.component";
import { PersistentRichTextSectionEntityComponent } from "./domain/textsection/rich-text-sections/text-section-entity/persistent-rich-text-section.component";
import { PersistentSimpleTextSectionEntityComponent } from "./domain/textsection/rich-text-sections/text-section-entity/persistent-simple-text-section.component";
import { TodolistAddDialogComponent } from "./domain/todolist/dialogs/todolist-add-dialog.component";
import { TodolistViewDialogComponent } from "./domain/todolist/dialogs/todolist-view-dialog.component";
import { TodolistComponent } from "./domain/todolist/todolist.component";
import { TransferAssetDialogComponent } from "./domain/transferasset/dialogs/transfer-asset-dialog.component";
import { TransferAssetEditorComponent } from "./domain/transferasset/editor/transfer-asset-editor.component";
import { TransferAssetItemComponent } from "./domain/transferasset/editor/transfer-asset-item.component";
import { TransferAssetSearchComponent } from "./domain/transferasset/search/transfer-asset-search.component";
import { UserEditorComponent } from "./domain/user/editor/user-editor.component";
import { UserItemComponent } from "./domain/user/editor/user-item.component";
import { UserSearchComponent } from "./domain/user/search/user-search.component";
import { AssetsUserDetailsEditorComponent } from "./domain/userdetails/editor/assets-user-details-editor.component";
import { AssetsUserDetailsItemComponent } from "./domain/userdetails/editor/assets-user-details-item.component";
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderMenuComponent } from './layout/header-menu/header-menu.component';
import { ServerErrorComponent } from "./pages/error/server-error.component";
import { UnauthorisedErrorComponent } from "./pages/error/unauthorised-error.component";
import { HomeComponent } from './pages/home/home.component';
import { AdminLandingPageComponent } from './pages/landing/admin/landing-page.component';
import { AssetsLandingPageComponent } from "./pages/landing/assets/landing-page.component";
import { PendingTransferAssetApproveComponent } from "./pages/landing/assets/pending-transfer-asset-approve.component";
import { FirearmsLandingPageComponent } from "./pages/landing/firearms/landing-page.component";
import { LandingPageHostDirective, LandingPageTitleDirective } from "./pages/landing/landing-page-host.directive";
import { LandingPageComponent } from "./pages/landing/landing-page.component";
import { LoginFailedDialogComponent } from "./pages/login/dialog/login-failed-dialog.component";
import { LoginComponent } from "./pages/login/login.component";
import { AuditRevisionInfoColumns } from "./shared/audit/audit-revision-info-columns.component";
import { UnauthorisedErrorInfoHandler } from './shared/error/unauthorised-error-info-handler';
import { RefCodeLookup } from "./shared/pipes/ref-code-lookup.pipe";
import { SafeHtmlPipe } from "./shared/pipes/safe-html.pipe";
import { FirearmDataUploadComponent } from "./domain/firearm/upload/firearm-data-upload.component";
import { FirearmReturnDialogComponent } from "./domain/firearm/dialog/firearm-return-dialog.component";
import { RangerAmmunitionIssueEmailTemplatesComponent } from "./domain/email-templates/ammunition/ranger-issue/ranger-ammunition-issue-email-template.component";
import { AmmunitionAcknowledgeIssueReturnComponent } from "./domain/ammunition_stock/acknowledge-issue-return/acknowledge-issue-return.component";
import { FirearmMaintenanceNotificationEmailTemplatesComponent } from "./domain/email-templates/firearms/maintenance-notification/firearm-maintenance-notification-email-template.component";
import { RangerOnLeaveDialogComponent } from "./domain/ranger/dialog/ranger-on-leave-dialog.component";
import { JustfoneDataTransferDialogComponent } from "./domain/datatransfer/dialog/justfone-data-transfer-dialog.component";
import { RangerDocumentEditDialogComponent, RangerDocumentRowsComponent } from "./domain/ranger/editor/ranger-document-rows.component";

registerLocaleData(localeEn, 'en-GB', localeEnExtra);

registerAssetModelCrudEntityConstructors();

@NgModule({
  imports: [
    AppRoutingModule,
    UimCommonModule,
    AssetsModelModule,
    AssetsServiceModule,
    QuillModule.forRoot(),
    MatPasswordStrengthModule.forRoot(),

    // these are exported by UimCommonModule, but still require explicit import to take effect
    AutosizeModule,
    // BrowserAnimationsModule,
    MatMomentDateModule,
    MatMomentDatetimeModule,
    MatStepperModule,
    CdkStepperModule
  ],
  declarations: [
    FirearmStorageLocationPLIEditorComponent, FirearmStorageLocationPLIItemComponent,
    FirearmStorageLocationPLISearchComponent, FirearmStorageLocationPLIDocumentComponent,    // FullHTMLReportViewerComponent,
    // HTMLReportViewerComponent,
    // InternalFileSearchComponent,
    // OptimisticLockErrorDialogComponent,
    // PasswordResetEmailTemplatesComponent,
    // UserWelcomeEmailTemplatesComponent,
    // WarningDialogComponent,
    AdminLandingPageComponent,
    AmmunitionStockEditorComponent,
    AmmunitionStockEventListComponent,
    AmmunitionStockEventListComponent,
    AmmunitionStockEventRowsComponent,
    AmmunitionStockEventRowsEditorComponent,
    AmmunitionStockEventSearchComponent,
    AmmunitionStockItemComponent,
    AmmunitionStockSearchComponent,
    AmmunitionStockEventHistoryComponent,
    AmmunitionAcknowledgeIssueReturnComponent,
    AppComponent,
    AssetAspectsControlComponent,
    AssetAuditListComponent,
    AssetEditorComponent,
    AssetItemComponent,
    AssetMaintenanceDocumentEditDialogComponent,
    AssetMaintenanceDocumentRowsComponent,
    AssetMaintenanceEditorComponent,
    AssetMaintenanceItemComponent,
    AssetMaintenanceRowsComponent,
    AssetMaintenanceSearchComponent,
    AssetSearchComponent,
    AssetSearchFiltersComponent,
    AssetSearchResultColumnsComponent,
    AssetTagsControlComponent,
    AssetTypeEditorComponent,
    AssetTypeEditorComponent,
    AssetTypeItemComponent,
    AssetTypeItemComponent,
    AssetTypeSearchComponent,
    AssetTypeSearchComponent,
    AssetAdditionalInfoControlComponent,
    AssetsLandingPageComponent,
    AssetDataUploadComponent,
    AssetsUserDetailsEditorComponent,
    AssetsUserDetailsItemComponent,
    AuditRevisionInfoColumns,
    BusinessUnitAddressEditorComponent,
    BusinessUnitAddressItemComponent,
    BusinessUnitAddressSearchComponent,
    BusinessUnitEditorComponent,
    BusinessUnitEmailContactEditorComponent,
    BusinessUnitEmailContactItemComponent,
    BusinessUnitEmailContactSearchComponent,
    BusinessUnitItemComponent,
    BusinessUnitSearchComponent,
    CostCentreEditorComponent,
    CostCentreItemComponent,
    CostCentreSearchComponent,
    ElectricalAspectItemComponent,
    ElectricalAspectItemComponent,
    ElectricalAspectSearchResultColumnsComponent,
    EmailTemplateParametersComponent,
    EmailTemplateParametersComponent,
    FirearmAcquireDialogComponent,
    FirearmAssignmentActivationDialogComponent,
    FirearmAssignmentApprovalDialogComponent,
    FirearmAssignmentCancellationDialogComponent,
    FirearmAssignmentCreationDialogComponent,
    FirearmAssignmentEditorComponent,
    FirearmAssignmentIssuePoliceNotifyEmailTemplatesComponent,
    FirearmAssignmentItemComponent,
    FirearmAssignmentListComponent,
    FirearmAssignmentLogEditorComponent,
    FirearmAssignmentLogItemComponent,
    FirearmAssignmentPendingActionListComponent,
    FirearmAssignmentPendingActionListComponent,
    FirearmAssignmentSearchComponent,
    FirearmAssignmentStorageAcquirePoliceNotifyEmailTemplatesComponent,
    FirearmAssignmentStorageDisposePoliceNotifyEmailTemplatesComponent,
    FirearmAssignmentStorageReturnPoliceNotifyEmailTemplatesComponent,
    FirearmAssignmentStorageTransferPoliceNotifyEmailTemplatesComponent,
    FirearmMaintenanceNotificationEmailTemplatesComponent,
    FirearmAuditListComponent,
    FirearmDisposeDialogComponent,
    FirearmDocumentRowsComponent,
    FirearmDocumentEditDialogComponent,
    FirearmEditorComponent,
    FirearmItemComponent,
    FirearmDataUploadComponent,
    FirearmPoolSearchComponent,
    FirearmPoolEditorComponent,
    FirearmPoolItemComponent,
    FirearmSearchComponent,
    FirearmSearchResultColumnsComponent,
    FirearmStorageLocationEditorComponent,
    FirearmStorageLocationEditorComponent,
    FirearmStorageLocationItemComponent,
    FirearmStorageLocationItemComponent,
    FirearmStorageLocationSearchComponent,
    FirearmStorageLocationSearchComponent,
    FirearmSuspendDialogComponent,
    FirearmReturnDialogComponent,
    FirearmTransferDialogComponent,
    FirearmsLandingPageComponent,
    FooterComponent,
    HeaderMenuComponent,
    HomeComponent,
    LandingPageComponent,
    LandingPageHostDirective,
    LandingPageTitleDirective,
    LoginComponent,
    LoginFailedDialogComponent,
    MaintenanceAspectItemComponent,
    MaintenanceAspectItemComponent,
    MaintenanceAspectSearchResultColumnsComponent,
    MechanicalAspectItemComponent,
    MechanicalAspectItemComponent,
    MechanicalAspectSearchResultColumnsComponent,
    PendingTransferAssetApproveComponent,
    PersistentRichTextSectionEntityComponent,
    PersistentSimpleTextSectionEntityComponent,
    RangerAcknowledgeAssignmentComponent,
    RangerAcknowledgeAssignmentComponent,
    RangerEditorComponent,
    RangerDocumentRowsComponent,
    RangerDocumentEditDialogComponent,
    RangerFirearmAssignmentLogEditorComponent,
    RangerFirearmAssignmentLogItemComponent,
    RangerItemComponent,
    RangerLeavingDialogComponent,
    RangerListComponent,
    RangerSearchComponent,
    RangerSetToPendingDialogComponent,
    RangerOnLeaveDialogComponent,
    RangerAmmunitionIssueEmailTemplatesComponent,
    RefCodeEditorComponent,
    RefCodeItemComponent,
    RefCodeLookup,
    RefCodeSearchComponent,
    RichTextSectionComponent,
    RoleEditorComponent,
    RoleItemComponent,
    RoleSearchComponent,
    SafeHtmlPipe,
    ServerErrorComponent,
    SimpleTextSectionComponent,
    SystemMessageDialogComponent,
    SystemMessageSearchComponent,
    TodolistAddDialogComponent,
    TodolistComponent,
    TodolistViewDialogComponent,
    TransferAssetDialogComponent,
    TransferAssetEditorComponent,
    TransferAssetItemComponent,
    TransferAssetSearchComponent,
    TransferReminderEmailTemplatesComponent,
    UnauthorisedErrorComponent,
    UserEditorComponent,
    UserItemComponent,
    UserSearchComponent,
    JustfoneDataTransferDialogComponent,
  ],
  entryComponents: [
    AdminLandingPageComponent,
    // FullHTMLReportViewerComponent,
    //HTMLReportViewerComponent,
    //OptimisticLockErrorDialogComponent,
    //RoleItemComponent,
    //UserItemComponent,
    //WarningDialogComponent,
  ],
  providers: [
    ErrorDialogComponent,
    RefCodeLookup,
    SafeHtmlPipe,
    BooleanFormatPipe,
    CdkColumnDef,
    CrudCanDeactivate,
    DatePipe,
    CurrencyPipe,
    {
      provide: CDK_DRAG_CONFIG, useValue: <DragDropConfig>{
        constrainPosition: dragConstrainPositionToWindowWithMargin()
      }
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: CurrentUserLoginInterceptor },
    {
      provide: DEBUG_SERVICE,
      useClass: DebugServiceImpl
    },
    {
      provide: CODE_LOOKUP_PIPE,
      useClass: RefCodeLookup
    },
    {
      provide: PRE_AUTH_SERVICE,
      useClass: OAuthPreAuthService,
      multi: true
    },
    {
      provide: PRE_AUTH_SERVICE,
      useClass: AuthTokenCookiePreAuthService,
      multi: true
    },
    {
      provide: PRE_AUTH_SERVICE,
      useClass: AuthTokenPreAuthService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: SystemMessageNotificationUtilService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: AssetMaintenanceNotificationUtilService,
      multi: true
    },
    {
      provide: AUTHENTICATION_REQUIRED_DECIDER,
      useClass: UnauthorizedAuthenticationRequiredDecider,
      multi: false
    },
    {
      provide: LOGIN_SUCCESS_INTERCEPTORS,
      useClass: CurrentUserLoginInterceptor,
      multi: true
    },
    {
      provide: LOGIN_SUCCESS_INTERCEPTORS,
      useClass: NavigationLoginInterceptor,
      multi: true
    },
    {
      provide: LOGIN_SUCCESS_INTERCEPTORS,
      useClass: FormStorageLoginInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PropegateTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BusyHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HateoasResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CurrentUserLoginInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NavigationLoginInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FormStorageLoginInterceptor,
      multi: true
    },
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    {
      provide: ERROR_INFO_HANDLERS,
      useClass: UnauthorisedErrorInfoHandler,
      multi: true
    },
    {
      provide: ERROR_INFO_HANDLERS,
      useClass: DialogErrorInfoHandler,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: SystemMessageNotificationUtilService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: ToDoListNotificationUtilService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: TransferAssetNotificationUtilService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: FirearmAssignmentNotificationService,
      multi: true
    },
    {
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: AmmunitionStockNotificationService,
      multi: true
    },
    {      
      provide: USER_NOTIFICATION_UTIL_SERVICE_PROVIDER,
      useClass: RangerNotifcationUtilService,
      multi: true
    },
    {
      provide: LINK_TOKEN_REPLACER,
      useClass: EnvironmentLinkTokenReplacer,
      multi: true
    },
    {
      provide: LINK_TOKEN_REPLACER,
      useClass: LocalStorageLinkTokenReplacer,
      multi: true
    },
    {
      provide: LINK_TOKEN_REPLACER,
      useClass: SessionStorageLinkTokenReplacer,
      multi: true
    },
    {
      provide: LINK_TOKEN_REPLACER,
      useClass: AuthTokenLinkTokenReplacer,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
